import {IBaseEntity, BaseEntity} from 'app/blocks/model/base-entity.model';
import {ICustomer} from 'app/blocks/model/customer.model';
import {IDeliveryPoint} from 'app/blocks/model/delivery-point.model';

export interface ICustomerProspectReport extends IBaseEntity {
    customer?: ICustomer;
    deliveryPoint?: IDeliveryPoint;
}

export class CustomerProspectReport extends BaseEntity implements ICustomerProspectReport {
    public customer?: ICustomer;
    public deliveryPoint?: IDeliveryPoint;

    constructor(customerProspectReport?) {
        super();
        if (customerProspectReport) {
            this.customer = customerProspectReport.customer;
            this.deliveryPoint = customerProspectReport.deliveryPoint;
        } else {
            // else
        }
    }
    clone(): CustomerProspectReport {
        return new CustomerProspectReport(this);
    }
}
